<template>
    <span>
        <v-autocomplete v-model="val" no-filter
            v-bind="{ required, multiple, disabled, chips, outlined, rounded, dense, prependIcon, appendIcon, hint, label, singleLine, clearable, rules, returnObject, itemText, itemValue }"
            :items="list" :search-input.sync="search" :loading="loading" :error-messages="errors" @click="onClick"
            @change="onChange">
            <!-- Pass on all named slots -->
            <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

            <!-- Pass on all scoped slots -->
            <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
                <slot :name="slot" v-bind="scope" />
            </template>
        </v-autocomplete>
        <input v-for="(e, index) in inputVals" type="hidden" v-bind="e" :key="index" />
    </span>
</template>
<script>
import _ from 'lodash'

export default {
    name: "ItemSelector",
    props: {
        name: { required: false },
        value: { required: false },
        label: { type: String, default: '' },
        itemText: { type: String, default: 'name' },
        itemValue: { type: String, default: 'id' },

        singleLine: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        outlined: {},
        rounded: {},
        dense: {},
        clearable: {},
        rules: {},


        multiple: { type: Boolean, default: false },
        chips: { type: Boolean, },

        hint: { type: String, required: false },

        action: { type: String, required: true },

        prependIcon: { type: String, },
        appendIcon: { type: String, },

        errors: {
            type: Array, default() {
                return []
            }
        },
        returnObject: { type: Boolean, default: true },
        debounce: { type: Number, default: 200 },
        preload: { type: Boolean, default: false },

        searchParam: { type: String, default: 's' },
        extraParams: { type: Object, default() { return {} } },
    },
    data() {
        let list = [];
        let val = null;
        if (this.value && (!Array.isArray(this.value) || this.value.length > 0)) {
            if (typeof this.value === 'object' && (!Array.isArray(this.value) || typeof this.value[0] === 'object')) {
                /// if object or array of object
                if (Array.isArray(this.value))
                    list = this.value;
                else {
                    this.list = [this.value];
                }
                val = this.value;

            } else {
                /// fetch single or array of ids
                //this.fetchId(this.value);
            }
        } else {
            val = this.value;
            list = [];
        }
        ///loadvalue will be triggered on mounted
        /*
        if (this.value && typeof this.value === 'object') {
            if (!Array.isArray(this.value) || (this.value.length > 0 && typeof this.value[0] === 'object')) {
                if (Array.isArray(this.value))
                    list = this.value;
                else
                    list.push(this.value);
                val = this.value;
            }
        }
        */
        return {
            _queryHash: JSON.stringify([this.searchParam, this.extraParams, this.search]),

            list,
            loading: false,
            search: null,
            val,

            debounceSearch: _.debounce(function (s) {
                this.fetchData(s);
            }, this.debounce),
        }
    },
    mounted() {
        this.loadValue();
        //if (this.list.length === 0 && this.value && (!Array.isArray(this.value) || this.value.length > 0)) {
        //    this.fetchId(this.value)
        //}
        if (this.list.length === 0 && this.preload)
            this.fetchData();
    },
    computed: {
        /*
        cachedItems(){
            let items = this.items || [];
            if(this.val !== null){
                let vals = Array.isArray(this.val) ? this.val :[this.val];
                let keys = vals.map(e=> e[this.itemKey]);
                // filter duplicates
                items = items.filter( e => !keys.includes(e[this.itemKey]));

                items.concat(vals);
            }

            return [];
        },
        */
        inputVals() {
            let vals = [];
            if (this.name !== undefined && this.name !== null && this.name !== '') {
                if (this.multiple) {
                    let i = 0;
                    for (let v of (Array.isArray(this.val) ? this.val : [this.val])) {
                        vals.push({
                            name: this.name + '[' + (i++) + ']',
                            value: (v && v[this.itemValue]) || v,
                        });
                    }
                } else {
                    vals.push({
                        name: this.name,
                        value: (this.val && this.val[this.itemValue]) || this.val,
                    });
                }
            }
            return vals;
        },
    },
    methods: {
        onParamChange() {
            let _queryHash = JSON.stringify([this.searchParam, this.extraParams, this.search]);

            if (this._queryHash !== _queryHash) {
                this.search && this.find(this.search);
            }
        },
        find(s) {
            this.loading = true;
            this.debounceSearch(s);
        },
        fetchData(s) {
            this.loading = true;
            this._queryHash = JSON.stringify([this.searchParam, this.extraParams, this.search]);

            let params = Object.assign({}, this.extraParams, { [this.searchParam]: s });

            axios.get(this.action, { params }).then(r => {
                this.list = r.data;
                //if (this.list.length === 1)
                //    this.val = this.list[0];
            }).catch(e => {
                console.log(e);
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchId(id) {
            this.loading = true;

            if (Array.isArray(id)) {
                axios.get(this.action, { params: { ids: id } })
                    .then(r => {
                        this.list = r.data;
                        this.val = this.list;
                    }).catch(e => {
                        console.log(e);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                axios.get(this.action, { params: { id } })
                    .then(r => {
                        this.list = r.data;
                        if (this.list.length === 1)
                            this.val = this.list[0];
                    }).catch(e => {
                        console.log(e);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        onClick() {
            if (this.list.length === 0 && !this.search) {
                this.fetchData();//<< Preload empty
            }
        },
        onChange(v) {
            this.$emit('change', v)
        },
        clear() {
            this.search = '';
            this.list = [];
            this.val = null;
        },
        loadValue() {
            // if not empty then load value
            if (this.value && (!Array.isArray(this.value) || this.value.length > 0)) {
                if (typeof this.value === 'object' && (!Array.isArray(this.value) || typeof this.value[0] === 'object')) {
                    /// if object or array of object
                    if (Array.isArray(this.value))
                        this.list = this.value;
                    else {
                        this.list = [this.value];
                    }
                    this.val = this.value;

                } else {
                    /// fetch single or array of ids
                    this.fetchId(this.value);
                }
            } else {
                this.val = this.value;
                this.list = [];
            }
        }
    },
    watch: {
        search(v) {
            this.$emit('update:search', v);
            this.onParamChange();
        },
        val(v) {
            //if (v && !this.returnObject)
            //    v = this.multiple ? v[this.itemValue] : v.map(e => e[this.itemValue]);
            this.$emit('input', v)
        },
        value(v) {
            if (JSON.stringify(this.value) !== JSON.stringify(this.val)) {
                this.loadValue();
            }
        },
        extraParams() {
            this.onParamChange();
        },
        searchParam() {
            this.onParamChange();
        },
    },
}
</script>
